import { mainApi } from "../services/main/api";

const extendedApi = mainApi.injectEndpoints({
    endpoints: builder => ({
        createAppeal: builder.query<CreateAppealResponse, CreateAppealRequest>({
            query: (request: CreateAppealRequest) => ({
                url: "createAppeal",
                body: request,
                method: "POST",
            }),
        }),
        getAppealDetails: builder.query<GetAppealDetailsResponse, GetAppealDetailsRequest>({
            query: (request: GetAppealDetailsRequest) => ({
                url: "getAppealDetails",
                body: request,
                method: "POST",
            }),
            providesTags: ["getAppealDetails"],
        }),
    }),
    overrideExisting: true,
});

export const { useGetAppealDetailsQuery, useLazyGetAppealDetailsQuery, useLazyCreateAppealQuery } =
    extendedApi;

export interface GetAppealDetailsRequest {
    businessUseCase: "SMART";
    propertyArtifactId?: string;

    [extraData: string]: any;
}

export interface GetAppealDetailsResponse {
    artifactCountMap: any;
    appealApproachCalculationData: any;
    SalesApproachDetailsMap: any;
    summary: any;

    [extraData: string]: any;
}

export interface CreateAppealRequest {
    businessUseCase: "SMART";
    propertyArtifactId?: string;
    clientName?: string;
    artifactCountMap?: any;
    appealApproachCalculationData?: any;
    SalesApproachDetailsMap?: any;
    summary?: any;

    [extraData: string]: any;
}

export interface CreateAppealResponse {
    message: any;
}
